import Variants from "./Variants";

export default Variants;
